import { icon } from './common'

const buttons = document.querySelectorAll(
  '.wp-block-button__link, .wpforms-submit, .vp-button, .vp-button-icon'
)
if (buttons.length > 0) {
  for (const el of buttons) {
    if (!el.querySelector('span:first-of-type')) el.innerHTML = button(el)
  }
}

export { button }

function button(el) {
  return `<span>${el.innerHTML}<span>${el.innerHTML}</span></span>`
}
